import PaySuiteMfePage from '@/components/paysuite/PaySuiteMfePage';

const MFE_INSTANCE_ID = 'a0a1eefa-da89-426d-9c95-e322036d9a66';

export default function PaymentDisputePage() {
  return (
    <PaySuiteMfePage
      title="Payment Disputes"
      description="Manage and resolve payment disputes"
      componentName="adyen-dispute"
      instanceId={MFE_INSTANCE_ID}
    />
  );
}
